import { useEffect, RefObject } from 'react';

import { useLocation } from 'wouter';

import { ArticleBlockJson, NullableHTMLDivElement } from '/types';
import { HttpError } from '/utils/HttpError';

const useScrollToBlock = (
  content: ArticleBlockJson[],
  ref: RefObject<NullableHTMLDivElement[]>,
  blockNum?: string,
): void => {
  const [location, setLocation] = useLocation();

  // If blockNum is passed in the URL set the URL to the blockId
  if (blockNum) {
    const block = content[parseInt(blockNum) - 1]; // From 1 based to 0 based indexing
    if (block) {
      // Find the location without the `blockNum`
      const baseLocation = location.replace(/(.*)(\/.+)$/, '$1');
      setLocation(`${baseLocation}#${block.id}`);
    } else {
      // eslint-disable-next-line no-console
      console.error(`block number ${blockNum} does not exist`);
      throw new HttpError('Not found', 404);
    }
  }

  // Scroll to blockId if one is passed in the URL. This is necessary to scroll
  // into block after finishing setting up the references on load.
  useEffect(() => {
    const match = window.location.href.match(/#workspace_SpacesStore_(.+?)$/);
    if (match) {
      const blockId = `workspace_SpacesStore_${match[1]}`;
      if (ref.current) {
        const blockElement = ref.current.find(
          (block) =>
            block &&
            block.children &&
            block.children[0].getAttribute('id') === blockId,
        );
        if (blockElement) {
          const carousel = blockElement.closest('.carousel-root');
          if (carousel) {
            carousel.scrollIntoView();
          } else {
            blockElement.scrollIntoView();
          }
        }
      }
    }
  }, [ref]);
};

export default useScrollToBlock;
